export default {
  id_nav_title: "身分認證",
  basic_nav_title: "基礎資訊",
  work_nav_title: "工作資訊",
  other_nav_title: "其他資訊",
  id_Fill_in_the_information_below: "請認真填寫下方資料",
  id_real_name: "真實姓名",
  id_p_real_name: "請輸入您的姓名",
  id_idcard_type: "證件類型",
  id_id_certification: "身分證認證",
  id_id_information: "身分證資訊",
  id_s_idcard_type: "請選擇證件類型",
  id_id_card: "身分證號",
  id_id_card_format: "請輸入正確的身分證號",
  id_p_id_card: "請輸入身分證號",
  id_sex: "性別",
  id_s_sex: "請選擇性別",
  id_sex_gg: "男",
  id_sex_mm: "女",
  id_birthday: "出生日期",
  id_s_birthday: "請選擇出生日期",
  id_update_idcard_positive: "請上傳身分證正面照",
  id_update_idcard_back: "請上傳身分證反面照",
  id_card_msg1: "2.請拍攝本人真實有效的身份證照片",
  id_card_msg2: "3.請確保身分證照片資訊真實有效、清晰可讀",
  id_update_idcard_hold: "請上傳手持身分證",
  id_bank_passbook_cover: "上傳本人銀行存摺封面",
  id_card_precautions: "注意事項: ",
  id_card_hold_msg1: "1.請在光線明亮的環境中拍攝",
  id_card_hold_msg2: "1.請確保手持身分證資訊清晰可讀",
  id_card_hold_msg3: "2.請確認臉部無遮擋，無其他人像與遮擋物",
  id_idcard_positive: "身分證正面照",
  id_idcard_back: "身分證反面照",
  id_idcard_hold: "手持身分證",
  id_passbook_cover: "本人銀行存摺封面",
  id_next_commit: "下一步",
  id_acknowledgment_msg: "確認訊息",
  id_p_acknowledgment_msg: "請檢查您的身分資料是否正確",
  id_p_address_info: "請輸入詳細地址",
  id_acknowledgment_name: "姓名",
  id_acknowledgment_idcard: "身分證字號",
  id_cancel_btn: "取消",
  id_confirm_btn: "確定",
  id_before_select_id_type: '請先選擇證件類型',
  id_before_upload_id_positive: '請先上傳證件正面',
  id_popup_select_text: '身分證明顯示完整，身分證號碼明顯。 ',
  id_select_idcard_eg: '證件上傳範例',
  id_select_idcard_detail_1: '缺邊',
  id_select_idcard_detail_2: '模糊',
  id_select_idcard_detail_3: '閃光',
  id_select_idcard_from_album: "從相簿選擇",
  id_select_idcard_from_camera: "拍照",
  id_select_know: '知道了',
  id_upload_fail: "上傳失敗",
  id_card_info_success: "身分資訊填入完成"
}